import { DatePipe } from '@angular/common';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { delay } from 'rxjs/operators';
import { EnumSolicitacaoCompraFornecedorStatus } from 'src/app/enum-types/enum-solicitacao-compra-fornecedor-status';
import { EnumSolicitacaoCompraTipoFrete } from 'src/app/enum-types/enum-solicitacao-compra-tipo-frete';
import { Cliente } from "../cadastro/cliente";
import { FornecedorProduto } from "../cadastro/fornecedor-produto";
import { ClienteService } from "../cadastro/service/cliente.service";
import { SolicitacaoCompraFornecedor } from "../persistences/solicitacao-compra-fornecedor";
import { Configuracoes } from "../services/configuracoes.service";
import { CotacaoService } from "../services/cotacao.service";
import { DateUtils } from "../utils/date-utils";
import { NumberUtils } from "../utils/number-utils";
import { SolicitacaoCompraItemCotacao } from "./solicitacao-compra-item-cotacao";
import { EventEmitter } from '@angular/core';

// Trocar o nome da classe
export class CotacaoManager {
	public nrSolicitacao: number;
	private cdFilial: number;
	public cotacao: SolicitacaoCompraFornecedor;
	public itensFiltro: SolicitacaoCompraItemCotacao[];
	public itensFiltroOriginal: SolicitacaoCompraItemCotacao[];
	public vlTotalPristino: number;
	
	//códigos do fornecedor
	public codsProdForn: FornecedorProduto[] = [];
	
	//unidades do fornecedor
	private unsMedidaForn: any;
	
	//filiais do fornecedor
	public filiais: Cliente[];
	
	public loadSuccess: boolean;
	
	//pra ficar visível no template
	public SolicitacaoCompraTipoFrete = EnumSolicitacaoCompraTipoFrete;
	public mostrarCdFabricante: boolean;
	private search: string;
	public numberMaskConfig2dec;
	public numberMaskConfigPc;
	public numberMaskConfig;
	public dtSolicitacao: string;
	possuiParcelas: boolean;
	variavelModificada = new EventEmitter<any>();

	constructor(
		private clienteLogado: Cliente,
		private cotacaoService: CotacaoService,
		private clienteService: ClienteService,
		private router: Router,
		private snackBar: MatSnackBar,
		public configuracoes: Configuracoes,
	) {
		this.numberMaskConfig2dec = NumberUtils.getMaskConfig(0, Number.MAX_VALUE, 2);
		this.numberMaskConfigPc = NumberUtils.getMaskConfig(0, 99, 2);
	}

	init(cdFilial: number, nrSolicitacao: number) {
		this.cdFilial = cdFilial;
		this.nrSolicitacao = nrSolicitacao;
		this.load();
	}

	setCdFilial(val: number) {
		this.cdFilial = val;
	}

	setNrSolicitacao(val: number) {
		this.nrSolicitacao = val;
	}

	private castToNumber(value) {
		if (typeof value === "number") {
			return value;
		}
		if (typeof value === "string") {
			return Number.parseFloat(value.replace(',', '.'));
		}
		return undefined;
	}

	recalculaCabecalho () {
		this.cotacao.vlFrete = this.castToNumber(this.cotacao.vlFrete);
	}

	recalculaItem(item: SolicitacaoCompraItemCotacao, calculaAliq = false,
		recalcVlTotal = true) {
		if (!item.vlBruto || !item.qtCotacao) { //NaN
			item.vlTotal = 0;
			return;
		}

		if (item.pcDesconto < 0) {
			item.pcDesconto *= -1;
		}

		item.vlLiquido = item.vlBruto;
		if (!Number.isNaN(item.pcDesconto)) {
			item.vlLiquido *= 1 - item.pcDesconto / 100;
		}
		else {
			item.pcDesconto = 0;
		}
		item.vlTotal = item.vlLiquido;

		const vlBase = item.vlLiquido;		
		item.ipiPcAliq = item.ipiPcAliq ? item.ipiPcAliq : 0;
		item.ipiValor = vlBase * item.ipiPcAliq / 100;
		item.vlTotal += vlBase * item.ipiPcAliq / 100;
		
		item.icmsPcAliquota = item.icmsPcAliquota ? item.icmsPcAliquota : 0;
		item.icmsValor = item.icmsValor ? item.icmsValor : 0;
		if (!calculaAliq) {
			item.icmsValor = item.vlBruto * item.icmsPcAliquota / 100;
			item.icmsValor = NumberUtils.round(item.icmsValor, 2);
		} else {
			item.icmsPcAliquota = item.icmsValor * 100 / vlBase;
			item.icmsPcAliquota = NumberUtils.round(item.icmsPcAliquota, 2);
		}

		const vlBaseComIPI = vlBase + item.ipiValor;
		item.icmsStPcAliquota = item.icmsStPcAliquota ? item.icmsStPcAliquota : 0;
		item.icmsStValor = item.icmsStValor ? item.icmsStValor : 0;
		if (!calculaAliq) {
			item.icmsStValor = vlBaseComIPI * item.icmsStPcAliquota / 100;
			item.icmsStValor = NumberUtils.round(item.icmsStValor, 2);
		} else {
			item.icmsStPcAliquota = item.icmsStValor * 100 / vlBaseComIPI;
			item.icmsStPcAliquota = NumberUtils.round(item.icmsStPcAliquota, 2);
		}
		item.vlTotal += item.icmsStValor;

		item.vlTotal *= item.qtCotacao;
		item.vlTotal = NumberUtils.round(item.vlTotal, 2);

		if (recalcVlTotal) {
			this.recalculaVlTotal();
		}

		this.recalculaCabecalho();
	}

	recalculaItens() {
		for (const item of this.cotacao.solicitacaoCompraItemCotacoes) {
			this.recalculaItem(item, false, false);
		}
		this.recalculaVlTotal();
	}

	public recalculaItemById(idItem: string, aliq: boolean) {
		for (const item of this.cotacao.solicitacaoCompraItemCotacoes) {
			if (item.solicitacaoCompraItem.item.idItem + '' == idItem) {
				this.recalculaItem(item, aliq);
				break;
			}
		}
		this.recalculaVlTotalComParcelas();
	}

	recalculaVlTotal() {
		let vlTotal = 0;

		for (const item of this.cotacao.solicitacaoCompraItemCotacoes) {
			if (item.vlTotal) {
				vlTotal += item.vlTotal;
			}
		}

		if (this.cotacao.vlFrete) {
			vlTotal += this.cotacao.vlFrete;
		}
		vlTotal = NumberUtils.round(vlTotal, 2);
		this.cotacao.vlTotal = vlTotal;
	}

	recalculaVlTotalComParcelas() {
		let vlTotal = 0;

		for (const item of this.cotacao.solicitacaoCompraItemCotacoes) {
			if (item.vlTotal) {
				vlTotal += item.vlTotal;
			}
		}

		if (this.cotacao.vlFrete) {
			vlTotal += this.cotacao.vlFrete;
		}
		vlTotal = NumberUtils.round(vlTotal, 2);
		this.recalcularParcelas(vlTotal, this.vlTotalPristino);
		this.cotacao.vlTotal = vlTotal;
	}

	recalcularParcelas(vlTotal: number, vlTotalPristino: number){
		if(this.cotacao.parcelas){
			if(this.cotacao.parcelas.length > 0){
				if(vlTotal === 0){
					this.possuiParcelas = false;
					this.cotacao.parcelas = [];
					return;
				}
				let valorTotalParcelas;
				valorTotalParcelas = 0;
				this.cotacao.parcelas.forEach( p => {
					if(typeof p.vlVcto === 'string'){
						p.vlVcto = parseFloat(p.vlVcto);
					}
					valorTotalParcelas += p.vlVcto;
				})
				valorTotalParcelas = parseFloat(valorTotalParcelas.toFixed(2));
				
				if(valorTotalParcelas === vlTotalPristino){
					for(let i = 0; i < this.cotacao.parcelas.length; i++){
						const percentual = (this.cotacao.parcelas[i].vlVcto * 100) / this.vlTotalPristino;
						const novoValor = (vlTotal * percentual) / 100;
						const valorParcelaArredondado = this.arredondarValor(novoValor);	
						const valorFinalParcela = parseFloat((valorParcelaArredondado).toFixed(2))
						this.cotacao.parcelas[i].vlVcto = valorFinalParcela;
					}
		
					if(this.cotacao.parcelas.length != 0){
						this.calculaUltimaParcela(vlTotal);
					}
					this.vlTotalPristino = vlTotal;
					this.variavelModificada.emit();
				} else{
					this.snackBar.open("Ajuste os valores das parcelas para terem a mesma soma que o valor total da cotação",null,{
						duration: 3500
					});
				}
			}	
		}
	}

	calculaUltimaParcela(vlTotal : number){
		let somaParcelas = 0;
		for(let i = 0; i < this.cotacao.parcelas.length - 1; i++){
			somaParcelas += this.cotacao.parcelas[i].vlVcto;
		}	
		const valor = vlTotal - somaParcelas;
		this.cotacao.parcelas[this.cotacao.parcelas.length -1].vlVcto = parseFloat(valor.toFixed(2));
	}

	getUnMedida(cot: SolicitacaoCompraItemCotacao): string {
		const unForn = this.unsMedidaForn[cot.idGeral.toString()];
		if (unForn !== undefined) {
			return unForn;
		}
		return cot.solicitacaoCompraItem.unSolicitada.unMedida;
	}

	getCdProdForn(cot: SolicitacaoCompraItemCotacao): string {
		const idx = this.codsProdForn.findIndex(
			val => val.item.idItem == cot.solicitacaoCompraItem.item.idItem);
		if (idx >= 0) {
			return this.codsProdForn[idx].cdProdutoForn;
		}
		return " - ";
	}

	getCdItem(cot: SolicitacaoCompraItemCotacao): string {
		return cot.solicitacaoCompraItem.item.cdItem;
	}

	onLoadCotacao(res: SolicitacaoCompraFornecedor) {		
		this.cotacao = res;
		this.vlTotalPristino = this.cotacao.vlTotal
		if(this.cotacao.parcelas != null){
			this.possuiParcelas = this.cotacao.parcelas.length > 0
		} else{
			this.possuiParcelas = false
		}
		if(this.possuiParcelas){
			if(this.cotacao.vlTotal === 0){
				this.cotacao.parcelas = [];
				this.possuiParcelas = false;
			}
			for(let i = 0; i < this.cotacao.parcelas.length; i++){
				const parts = this.cotacao.parcelas[i].dtVcto.split(' ');
	
				const partesData = parts[0].split('/')
				// Formatar a data para o formato desejado
				const dataInput = partesData[0] + '/' +partesData[1] + '/' + partesData[2];
				this.cotacao.parcelas[i].dtVctoFormatada = dataInput;
			}
		}
		
		this.itensFiltroOriginal = JSON.parse(JSON.stringify(res.solicitacaoCompraItemCotacoes));
		if (this.cotacao.solicitacaoCompra != undefined) {
			const timestamp = this.cotacao.solicitacaoCompra.dtSolicitacao;						
			const datePipe = new DatePipe('en-US');
			const date = datePipe.transform(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss');
			this.dtSolicitacao = date.toString();
		}

		this.mostrarCdFabricante = this.cotacao.solicitacaoCompraItemCotacoes
			.findIndex(itemCot => !!itemCot.solicitacaoCompraItem.item.itemProduto.cdFabricante)
			!= -1;

		if (this.cotacao.flStatus == EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.FECHADO][0]) {			
			this.cotacaoService.setEmEdicao(this.cotacao)
				.subscribe((res) => {
					this.mostrarNotificacao(res);								
					this.cotacao.flStatus = EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.ABERTO][0];					
					this.mostrarNotificacao(res);					
					this.onLoad();
				});
		}

		this.cotacaoService.getUnidadesFornecedor(this.cotacao)
			.subscribe(res => {
				this.unsMedidaForn = res;
				this.onLoad();
			}, this.onError);

		this.cotacaoService.getCodigosFornecedor(this.cotacao)
			.subscribe(res => { 
				this.codsProdForn = res; 
				this.onLoad();
			}, this.onError);

		this.clienteService.getFiliais()
			.subscribe(res => {
				this.filiais = res;
				this.cotacao.solicitacaoCompraItemCotacoes
					.filter(item => item.fornecedorFaturamento)
					.forEach(
						item => item.fornecedorFaturamento = this.filiais.find(
							f => f.cdCliente == item.fornecedorFaturamento.cdCliente));

				this.cotacao.solicitacaoCompraItemCotacoes
					.filter(item => !item.fornecedorFaturamento)
					.forEach(
						item => item.fornecedorFaturamento = this.filiais.find(
							f => f.cdCliente == this.clienteLogado.cdCliente)
					);

				this.itensFiltro = this.cotacao.solicitacaoCompraItemCotacoes;

				this.onLoad();
			}, this.onError);
	}

	onLoad() {
		if (this.unsMedidaForn && 
			this.codsProdForn && 
			this.filiais && 
			this.cotacao.flStatus == EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.ABERTO][0] &&
			this.numberMaskConfig
			) {				
			this.recalculaItens();
			this.loadSuccess = true;
		}
	}

	onError(res: Response) {
		console.log(res.toString());
	}

	load() {
		this.loadSuccess = null;
		this.cotacaoService.getCotacao(this.cdFilial, this.nrSolicitacao)
			.subscribe(res => 
				this.onLoadCotacao(res), ()=> { localStorage.getItem('access_token') ? this.router.navigateByUrl('/home') : this.router.navigateByUrl('/login'); this.onError }
				);
		
		this.configuracoes.getConfigNumber()
			.subscribe(casasDecimais => {
				this.numberMaskConfig = NumberUtils.getMaskConfig(0, Number.MAX_VALUE, parseInt(casasDecimais));
				this.onLoad();
			}, this.onError)		
	}

	send(ordenacao: string[]) {
		let valorParcelas: number
		valorParcelas = 0;
		if(this.cotacao.parcelas){
			for(let i = 0; i < this.cotacao.parcelas.length; i++){
				if(i + 1 < this.cotacao.parcelas.length){
					const partesData = this.cotacao.parcelas[i].dtVctoFormatada.split('/')
					const partesProximaData = this.cotacao.parcelas[i + 1].dtVctoFormatada.split('/')
					const dataAtual = new Date(parseInt(partesData[2]),parseInt(partesData[1]) - 1, parseInt(partesData[0]));
					const proximaData = new Date(parseInt(partesProximaData[2]),parseInt(partesProximaData[1]) - 1, parseInt(partesProximaData[0]));
					// Verificar se a data atual é maior que a próxima data
					if(isNaN(dataAtual.getTime()) || isNaN(proximaData.getTime())){
						this.mostrarNotificacao(`Data da parcela inválida`);
						return
					}
					if (dataAtual > proximaData) {
						this.mostrarNotificacao(`A data da parcela ${i + 1} é posterior à data da parcela ${i + 2}`);
						return;
					}
				}
				if(i + 1 < this.cotacao.parcelas.length){
					if(+this.cotacao.parcelas[i].vlVcto === 0){
						this.mostrarNotificacao(`O valor da parcela ${i + 1} não pode ser 0`);
						return
					}
					valorParcelas = valorParcelas + +this.cotacao.parcelas[i].vlVcto;
				}
				if(i + 1 === this.cotacao.parcelas.length) {
					const partesData = this.cotacao.parcelas[i].dtVctoFormatada.split('/')
					const dataAtual = new Date(parseInt(partesData[2]),parseInt(partesData[1]) - 1, parseInt(partesData[0]));
					// Verificar se a data atual é maior que a próxima data
					if(isNaN(dataAtual.getTime())){
						this.mostrarNotificacao(`Data da parcela inválida`);
						return
					}
					if(+this.cotacao.parcelas[i].vlVcto === 0){
						this.mostrarNotificacao(`O valor da parcela ${i + 1} não pode ser 0`);
						return
					}
					valorParcelas = valorParcelas + +this.cotacao.parcelas[i].vlVcto;
					valorParcelas = parseFloat(valorParcelas.toFixed(2));
					if( valorParcelas != this.cotacao.vlTotal){
						this.mostrarNotificacao(`A soma dos valores das parcelas não é igual ao valor da cotação total`);
						return;
					}
				}
			}
			for(let i = 0; i < this.cotacao.parcelas.length; i++){
				const partesData = this.cotacao.parcelas[i].dtVctoFormatada.split('/')
				const data = new Date(parseInt(partesData[2]),parseInt(partesData[1]) - 1, parseInt(partesData[0]));
				const dia = data.getDate().toString().padStart(2, '0');
				const mes = (data.getMonth() + 1).toString().padStart(2, '0');
				const ano = data.getFullYear();
				this.cotacao.parcelas[i].dtVcto = `${dia}/${mes}/${ano}` +  ' 03:00:00';
			}
		}
		if (this.filiais.length == 1) {
			this.cotacao.solicitacaoCompraItemCotacoes.forEach(i => i.fornecedorFaturamento = this.filiais[0]);
		}

		let selectedDate = this.cotacao.dtValidade !== null ? this.converterData(this.cotacao.dtValidade) : null;
		const currentDate = DateUtils.removeTime(new Date());
		if (!selectedDate
			|| Number.isNaN(selectedDate.getTime())
			|| currentDate.getTime() > selectedDate.getTime()
			|| selectedDate.getFullYear() > 2100) {
			this.mostrarNotificacao("Data de validade é inválida.");
			return;
		}
		selectedDate = this.cotacao.dtFaturamento !== null ? this.converterData(this.cotacao.dtFaturamento) : null;
		if (!selectedDate
			|| Number.isNaN(selectedDate.getTime())
			|| currentDate.getTime() > selectedDate.getTime()
			|| selectedDate.getFullYear() > 2100) {
			this.mostrarNotificacao("Data de faturamento é inválida.");
			return;
		}

		this.rateiaFrete();

		for(let i = 0; i < this.cotacao.solicitacaoCompraItemCotacoes.length; i++){
			if(typeof this.cotacao.solicitacaoCompraItemCotacoes[i].cstOrigem === 'string'){
				if(this.cotacao.solicitacaoCompraItemCotacoes[i].cstOrigem.trim() === ''){
					this.cotacao.solicitacaoCompraItemCotacoes[i].cstOrigem = null
				}
			}
		}

		if(this.cotacao.tpFrete === null){
			this.mostrarNotificacao("Tipo de frete não pode ser vazio.");
			return;
		}

		this.cotacao.ordenacaoPortal = ordenacao.join(', ');

		this.cotacao.solicitacaoCompraItemCotacoes.forEach(i => {
			if(i.dtPrevisaoEntrega != undefined || i.dtPrevisaoEntrega != null){
				if(i.dtPrevisaoEntrega.trim() == '')
					i.dtPrevisaoEntrega = null;
			}
		})

		this.cotacaoService.enviarCotacoes(this.cotacao)
			.subscribe(() => {
				if (this.cotacao.flStatus == EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.FECHADO][0]) {
					this.mostrarNotificacao("Enviado");
				} else {
					this.mostrarNotificacao("Alterado");
				}
				//replaceUrl: não permitir voltar para esta página pelo histórico, para evitar marcar como em edição
				this.router.navigateByUrl("/lista-cotacoes", { replaceUrl: true });
			}, (res: Response) => console.log(res.toString()));
	}

	rateiaFrete () {
		let somaRateio = this.cotacao.vlFrete;

		let c = 0;
		let i = 0;
		for (const item of this.cotacao.solicitacaoCompraItemCotacoes) {
			item.vlFrete = NumberUtils.round(this.cotacao.vlFrete * this.getFreteProporcao(item), 4);
			somaRateio -= item.vlFrete;
			if (item.vlFrete > 0) {
				i = c;
			}
			c++;
		}
		this.cotacao.solicitacaoCompraItemCotacoes[i].vlFrete += somaRateio;
	}

	getFreteProporcao (item: SolicitacaoCompraItemCotacao): number {
		if (item.vlTotal == undefined) {
			return 0;
		}
		return (item.vlTotal / (this.cotacao.vlTotal - this.cotacao.vlFrete));
	}

	send2(): boolean {
		if (this.filiais.length == 1) {
			this.cotacao.solicitacaoCompraItemCotacoes.forEach(i => i.fornecedorFaturamento = this.filiais[0]);
		}
		const selectedDate = this.converterData(this.cotacao.dtValidade);		
		const currentDate = DateUtils.removeTime(new Date());

		if (!selectedDate
			|| Number.isNaN(selectedDate.getTime())
			|| currentDate.getTime() > selectedDate.getTime()
			|| selectedDate.getFullYear() > 2100) {
			return false;
		}
		this.cotacaoService.enviarCotacoes(this.cotacao).subscribe();
		return true;
	}

	finaliza() {
		this.cotacao.flStatus = EnumSolicitacaoCompraFornecedorStatus[EnumSolicitacaoCompraFornecedorStatus.FECHADO][0];
	}
	
	filtraItens(search: string) {
		search = search.toUpperCase();
		this.search = search;

		of(search)
			.pipe(
				delay(500) // 500ms
			)
			.subscribe((s) => {
				if (s == this.search) {
					if (s.length == 0) {
						this.itensFiltro = this.cotacao.solicitacaoCompraItemCotacoes;
					} else {
						this.itensFiltro = this.cotacao.solicitacaoCompraItemCotacoes.filter((c) => {
							const item = c.solicitacaoCompraItem.item;
							return (
								item.nmItem.indexOf(search) != -1 ||
								item.itemProduto.cdFabricante.toUpperCase().indexOf(search) != -1 ||
								this.getCdItem(c).toUpperCase().indexOf(search) != -1
							);
						});
					}
				}
			});
	}

	ordenaItens(A: string, B: string, C: string) {
		if(A === '' && B === '' && C === ''){
			this.itensFiltro.sort((a,b) => {
				const indexA = this.itensFiltroOriginal.findIndex(item => item.idGeral === a.idGeral);
				const indexB = this.itensFiltroOriginal.findIndex(item => item.idGeral === b.idGeral);
			
				return indexA - indexB
			})
		} else{
			this.itensFiltro.sort(function (a, b) {
			
				// Primeiro pega os atributos na ordem recebida
				const dictA: { [id: string]: string } = {};
				const dictB: { [id: string]: string } = {};
				//"Descrição", "Cod. Fabricante", "Marca"
				// Usar dict para garantir a ordem
				dictA["Cod. Fabricante"] = a.solicitacaoCompraItem.item.itemProduto.cdFabricante;
				dictA["Descrição"] = a.solicitacaoCompraItem.item.nmItem;
				dictA["Marca"] = a.solicitacaoCompraItem.item.itemProduto.marca.nmMarca;
	
				dictB["Cod. Fabricante"] = b.solicitacaoCompraItem.item.itemProduto.cdFabricante;
				dictB["Descrição"] = b.solicitacaoCompraItem.item.nmItem;
				dictB["Marca"] = b.solicitacaoCompraItem.item.itemProduto.marca.nmMarca;
	
				// Coloca os valores em variaveis locais
				const a1 = dictA[A];
				const a2 = dictA[B];
				const a3 = dictA[C];
	
				const b1 = dictB[A];
				const b2 = dictB[B];
				const b3 = dictB[C];
	
				// Ordenar
				if (a1 == b1) {
					if (a2 == b2) {
						if (a3 > b3) {
							return 1;
						}
						else if (a3 == b3) {
							return 0;
						}
						return -1;
					}
					else {
						if (a2 > b2) {
							return 1;
						}
						return -1;
					}
				}
				else {
					if (a1 > b1) {
						return 1;
					}
					return -1;
				}
			});
		}
	}


	mostrarNotificacao(text: string) {
		this.snackBar.open(text, null, {
			duration: 2000
		});
	}


	scroll(id: string) {
		document.getElementById(id).scrollIntoView();
	}


	getData(): string {
		return this.cotacao.solicitacaoCompra.dtSolicitacao.toLocaleDateString();
	}


	salvarItem(item: SolicitacaoCompraItemCotacao) {
		this.cotacaoService.enviarItem(item).subscribe();
	}

	salvarItemById (idItem: string) {
		for (const item of this.cotacao.solicitacaoCompraItemCotacoes) {
			if (item.solicitacaoCompraItem.item.idItem + '' == idItem) {
				this.salvarItem(item);
				break;
			}
		}
	}


	validaPercentual(percent: number, name: string): boolean {
		const elem: HTMLElement = document.getElementById(name); 
		if (percent < 0) {
			elem.style.color = "red";
			
			setTimeout(
				function () { 
					elem.focus();
				},
				50
			);

			return false;
		}
		else {
			elem.style.color = "black";
		}

		return true;
	}

	converterData(dataPtBr: string): Date {
		const partes = dataPtBr.split('/');
		const dia = parseInt(partes[0], 10);
		const mes = parseInt(partes[1], 10) - 1;
		const ano = parseInt(partes[2], 10);
		
		return new Date(ano, mes, dia);
	}	

	arredondarValor(valor: number): number {    
		return Math.round(valor * 100) / 100;
	}
}
